import { index, int, json, mysqlTable, text, timestamp, uniqueIndex, varchar } from "drizzle-orm/mysql-core";

/** One meeting-minutes request per sales appointment (0289). */
export const appointmentMinutesRequests = mysqlTable(
  "appointment_minutes_requests",
  {
    id: int("id").autoincrement().primaryKey(),
    appointmentId: int("appointmentId").notNull(),
    token: varchar("token", { length: 32 }).notNull(),
    status: varchar("status", { length: 32 }).notNull().default("claimed"),
    salespersonUserId: int("salespersonUserId"),
    salespersonName: varchar("salespersonName", { length: 255 }),
    salespersonEmail: varchar("salespersonEmail", { length: 320 }),
    customerId: int("customerId"),
    appointmentTitle: varchar("appointmentTitle", { length: 500 }),
    appointmentStartsAt: timestamp("appointmentStartsAt"),
    appointmentEndsAt: timestamp("appointmentEndsAt"),
    gmailThreadId: varchar("gmailThreadId", { length: 128 }),
    requestGmailMessageId: varchar("requestGmailMessageId", { length: 128 }),
    requestRfcMessageId: varchar("requestRfcMessageId", { length: 512 }),
    lastOutboundRfcMessageId: varchar("lastOutboundRfcMessageId", { length: 512 }),
    outboundGmailIdsJson: json("outboundGmailIdsJson").$type<string[] | null>(),
    processedInboundIdsJson: json("processedInboundIdsJson").$type<string[] | null>(),
    sendAttempts: int("sendAttempts").notNull().default(0),
    requestSentAt: timestamp("requestSentAt"),
    reminderSentAt: timestamp("reminderSentAt"),
    clarificationCount: int("clarificationCount").notNull().default(0),
    lastClarifyingQuestion: text("lastClarifyingQuestion"),
    lastReplyAt: timestamp("lastReplyAt"),
    replyText: text("replyText"),
    minutesText: text("minutesText"),
    llmVerdictJson: json("llmVerdictJson").$type<Record<string, unknown> | null>(),
    matchedCustomerId: int("matchedCustomerId"),
    customerLogId: int("customerLogId"),
    completedAt: timestamp("completedAt"),
    lastError: varchar("lastError", { length: 500 }),
    digestReportedAt: timestamp("digestReportedAt"),
    createdAt: timestamp("createdAt").defaultNow().notNull(),
    updatedAt: timestamp("updatedAt").defaultNow().onUpdateNow().notNull(),
  },
  (t) => ({
    apptUq: uniqueIndex("appointment_minutes_requests_appt_uq").on(t.appointmentId),
    tokenUq: uniqueIndex("appointment_minutes_requests_token_uq").on(t.token),
    statusIdx: index("appointment_minutes_requests_status_idx").on(t.status, t.updatedAt),
  }),
);

/** Gmail OAuth connection for the Cleo mailbox (claritygroupsg@gmail.com) used to send + read minutes. */
export const salesMinutesMailboxConnections = mysqlTable(
  "sales_minutes_mailbox_connections",
  {
    id: int("id").autoincrement().primaryKey(),
    accountEmail: varchar("accountEmail", { length: 320 }).notNull(),
    lifecycle: varchar("lifecycle", { length: 32 }).notNull().default("enabled"),
    refreshTokenCiphertext: text("refreshTokenCiphertext"),
    refreshTokenIv: varchar("refreshTokenIv", { length: 64 }),
    refreshTokenAuthTag: varchar("refreshTokenAuthTag", { length: 64 }),
    grantedScopesJson: json("grantedScopesJson").$type<string[] | null>(),
    lastPollAt: timestamp("lastPollAt"),
    lastSafeErrorCode: varchar("lastSafeErrorCode", { length: 64 }),
    activeSlot: int("activeSlot"),
    connectedByUserId: int("connectedByUserId"),
    connectedAt: timestamp("connectedAt"),
    createdAt: timestamp("createdAt").defaultNow().notNull(),
    updatedAt: timestamp("updatedAt").defaultNow().onUpdateNow().notNull(),
  },
  (t) => ({
    activeUq: uniqueIndex("sales_minutes_mailbox_active_uq").on(t.activeSlot),
  }),
);

export const salesMinutesOauthStates = mysqlTable(
  "sales_minutes_oauth_states",
  {
    id: int("id").autoincrement().primaryKey(),
    stateHash: varchar("stateHash", { length: 128 }).notNull(),
    initiatingUserId: int("initiatingUserId").notNull(),
    expiresAt: timestamp("expiresAt").notNull(),
    consumedAt: timestamp("consumedAt"),
    createdAt: timestamp("createdAt").defaultNow().notNull(),
  },
  (t) => ({
    hashUq: uniqueIndex("sales_minutes_oauth_states_hash_uq").on(t.stateHash),
  }),
);

export type AppointmentMinutesRequest = typeof appointmentMinutesRequests.$inferSelect;
